import { render } from "./SampleData.vue?vue&type=template&id=fb6e9628&scoped=true"
import script from "./SampleData.vue?vue&type=script&lang=js"
export * from "./SampleData.vue?vue&type=script&lang=js"

import "./SampleData.vue?vue&type=style&index=0&id=fb6e9628&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6e9628"]])

export default __exports__